import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HomeService } from '../home-service/home.service';

@Component({
  selector: 'app-bloco-novas-oportunidades',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './bloco-novas-oportunidades.component.html',
  styleUrls: ['./bloco-novas-oportunidades.component.scss'],
})
export class BlocoNovasOportunidadesComponent implements OnInit {
  private readonly BASE_IMG_URL       = 'https://app.rededeobras.com.br/Img_Obras/';
  private readonly BASE_IMG_PARCEIRO  = 'https://app.rededeobras.com.br/';

  private readonly MODULOS_PARCEIRO = ['Industrial', 'Infraestrutura', 'Edificações'];

  grupos: any[] = [];
  loading = true;
  obraIds: number[] = [];

  @Output() abrirFicha = new EventEmitter<{
    workID: number;
    obraIds: number[];
    modulo: string;
  }>();

  constructor(private readonly homeService: HomeService) {}

  ngOnInit(): void {
    this.loadOportunidades();
  }

  private loadOportunidades(): void {
    this.homeService.getNewOpportunities(15).subscribe({
      next: (res) => {
        const groups = res?.data || [];

        this.grupos = groups.map((g: any) => ({
          moduleID        : g.moduleID,
          moduleName      : g.moduleName,
          isAccessModule  : g.isAccessModule,
          works: (g.works || [])
            .slice(0, 6)
            .map((w: any) => ({
              workID        : w.workID,
              workName      : w.workName,
              companyName   : w.companyName,
              workPhase     : w.workPhase,
              workImage     : w.workImage,
              moduleName    : g.moduleName,
              isAccessModule: g.isAccessModule,
              updatedAt      : this.formatDate(w.updatedAt),
            })),
        }));

        this.obraIds = this.grupos.flatMap((g) => g.works.map((w: any) => w.workID));
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  private formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit', month: '2-digit',
    });
  }

  getModuleColorClass(moduleName: string): string {
    const name = (moduleName || '').toLowerCase();
    if (name.includes('industrial')) return 'modulo-industrial';
    if (name.includes('infraestrutura')) return 'modulo-infraestrutura';
    if (name.includes('edificações') || name.includes('edificacoes')) return 'modulo-edificacoes';
    return '';
  }

  getImageUrl(obra: any): string | null {
    if (!obra?.workImage) return null;

    const usaPastaParceiro = this.MODULOS_PARCEIRO.includes(obra.moduleName);
    const base = usaPastaParceiro ? this.BASE_IMG_PARCEIRO : this.BASE_IMG_URL;

    return `${base}${obra.workImage}`;
  }

  getModuloSlug(moduleName: string): string {
    return (moduleName || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  abrirFichaObra(obra: any): void {
    if (!obra.isAccessModule) {
      alert('Esse m\u00F3dulo n\u00E3o est\u00E1 liberado na sua plataforma');
      return;
    }

    const grupo = this.grupos.find((g) => g.moduleName === obra.moduleName);
    const obraIds = grupo
      ? grupo.works.map((w: any) => w.workID)
      : this.obraIds;

    this.abrirFicha.emit({
      workID: obra.workID,
      obraIds,
      modulo: this.getModuloSlug(obra.moduleName),
    });
  }
}